module.exports = __webpack_public_path__ + "f225aa8c81040c5e01435984b4418af4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2023_chart.png
// module id = 1705
// module chunks = 0